module.exports = __webpack_public_path__ + "media/images/icons/flags/TT-2533a4c1c0f35f3a67ed941e3e71107b.svg";